// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__hx53S","itemTitle":"ClientEmergencyInfo_itemTitle__2qKbd","itemText":"ClientEmergencyInfo_itemText__1oJku"};